<template>
  <div class="jps-iframe">
    <iframe v-if="attrs" v-bind="attrs"></iframe>
  </div>
</template>

<script lang="ts" setup>
const parser = new DOMParser()
const allowedAttributes = [
  'allow',
  'allowfullscreen',
  'name',
  'height',
  'width',
  'src',
  'title',
]

interface Props {
  src: string
}
const props = withDefaults(defineProps<Props>(), {})

const attrs = computed(() => {
  const doc = parser.parseFromString(props.src, 'text/html')
  const iframe = doc.getElementsByTagName('iframe')[0]
  if (iframe) {
    const attrs = {}
    iframe
      .getAttributeNames()
      .filter(n => allowedAttributes.includes(n))
      .forEach(n => {
        attrs[n] = iframe.getAttribute(n) ? iframe.getAttribute(n) : true
      })
    return attrs
  } else {
    return null
  }
})
</script>

<style lang="scss" scoped>
.jps-iframe {
  display: flex;
  justify-content: center;
}
</style>
